import React from 'react'
import { Link } from 'react-router-dom'

/** Карточка матчинг-тикета пополнения: то, что мэтчинг решил по этому депозиту. */
export const matchingTicketCardUrl = (token: string): string =>
  '/matching/payment/card/' + token

/** Карточка выплаты в матчинговом разделе: её депозиты и действия над ней. */
export const matchingPayoutCardUrl = (token: string): string =>
  '/matching/payout/card/' + token

/** Active matching deposits list filtered by one deposit: it is listed in any status once it entered matching. */
export const matchingActiveDepositsUrl = (token: string): string =>
  '/matching/payment/active?ticket=' + encodeURIComponent(token)

type Props = {
  /** Токен тикета. Пусто — прочерк, ссылки нет. */
  token?: string | null
  /** Тип тикета: у депозита и у выплаты свои матчинговые карточки. */
  type?: 'payment' | 'payout'
  className?: string
  empty?: React.ReactNode
}

/**
 * Токен тикета **внутри матчингового раздела**: ведёт на матчинговую карточку, а не на полную
 * карточку тикета. Это разные сущности, и из раздела мэтчинга ожидается матчинговая: у депозита —
 * решение, кандидаты, связанная выплата; у выплаты — её депозиты и действия.
 *
 * Вне мэтчинга токен депозита рисуется `DepositTokenLink`, токен выплаты — `PayoutTokenLink`.
 */
export const MatchingTicketLink: React.FC<Props> = ({
  token,
  type = 'payment',
  className,
  empty = '-',
}) => {
  if (!token) return <>{empty}</>

  return (
    <Link
      to={type === 'payout' ? matchingPayoutCardUrl(token) : matchingTicketCardUrl(token)}
      target='_blank'
      className={className ?? 'text-primary'}
      onClick={(e) => e.stopPropagation()}
    >
      {token}
    </Link>
  )
}

export default MatchingTicketLink
